// Central configuration for the API Base URL
// Use the cloud server IP for production, and localhost for local development
const isLocalhost = 
  window.location.hostname === 'localhost' || 
  window.location.hostname === '127.0.0.1' || 
  window.location.hostname.startsWith('192.168.') || 
  window.location.hostname.startsWith('10.') || 
  window.location.hostname.endsWith('.local');

export const API_BASE = isLocalhost
  ? `http://${(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '127.0.0.1' : window.location.hostname}:8000/api`
  : 'https://convertalldocs.com/api';

export default {
  API_BASE,
};
